export const domodiTransactionMapper = (cookies, data) => ({
    productIds: data.c_item_ids,
    orderValue: data.c_value,
    shopId: cookies.domodi.shopId,
    userId: cookies.domodi.userId,
    timeOfEvent: new Date().toISOString(),
    timeOfVisit: cookies.domodi.time,
    atid2: cookies.domodi.id,
    ath2: cookies.domodi.hash,
    orderId: data.c_transaction_id || '',
    v: process.env.APP_VERSION
});

export const allaniTransactionMapper = (cookies, data) => {
    const pixel = {
        pids: data.c_item_ids,
        oval: data.c_value,
        tid: cookies.allani.id,
        th: cookies.allani.hash,
        ver: data.v
    };

    if (data.c_transaction_id) {
        pixel.oid = data.c_transaction_id;
    }

    return pixel;
};

